/**
 * Returns true if the two numbers are equal within the given precision
 * (i.e. the absolute difference is strictly less than precision).
 * Default precision is 0.01.
 */
export function isFloatEqual(
  a: number,
  b: number,
  precision: number = 0.01
): boolean {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return false;
  return Math.abs(a - b) < precision;
}
